import { Modal } from "@/shared/components/Modal";
import { Button } from "@/shared/components/form/Button";
import { AlertTriangle } from "lucide-react";
import useTranslations from "@/shared/lang/useTranslations";

type DeleteNoteModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  noteTitle?: string;
  isLoading?: boolean;
};

export const DeleteNoteModal = ({
  isOpen,
  onClose,
  onConfirm,
  noteTitle = "",
  isLoading = false,
}: DeleteNoteModalProps) => {
  const { t } = useTranslations("news");
  const message =
    noteTitle.trim() !== ""
      ? t("delete_modal_message_with_title", { title: noteTitle })
      : t("delete_modal_message_no_title");

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("delete_modal_title")}
      size="md"
      footer={
        <>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            {t("delete_modal_cancel")}
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
            className="bg-red-500 hover:bg-red-600 active:bg-red-700 focus:ring-red-500 disabled:bg-red-400 dark:bg-red-600 dark:hover:bg-red-500 dark:active:bg-red-600 dark:disabled:bg-red-700"
          >
            {t("delete_modal_confirm")}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 flex items-start gap-3">
          <AlertTriangle className="h-5 w-5 text-red-600 dark:text-red-500 shrink-0 mt-0.5" />
          <p className="text-sm font-medium text-red-800 dark:text-red-200">
            {t("delete_modal_warning")}
          </p>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-400">{message}</p>
      </div>
    </Modal>
  );
};
